var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    rx: 6,
    fill: "#3B58FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 26C21.95 26 21.4793 25.8043 21.088 25.413C20.6967 25.0217 20.5007 24.5507 20.5 24V14C20.5 13.45 20.696 12.9793 21.088 12.588C21.48 12.1967 21.9507 12.0007 22.5 12C23.0493 11.9993 23.5203 12.1953 23.913 12.588C24.3057 12.9807 24.5013 13.4513 24.5 14V24C24.5 24.55 24.3043 25.021 23.913 25.413C23.5217 25.805 23.0507 26.0007 22.5 26ZM14.5 26C13.95 26 13.4793 25.8043 13.088 25.413C12.6967 25.0217 12.5007 24.5507 12.5 24V14C12.5 13.45 12.696 12.9793 13.088 12.588C13.48 12.1967 13.9507 12.0007 14.5 12C15.0493 11.9993 15.5203 12.1953 15.913 12.588C16.3057 12.9807 16.5013 13.4513 16.5 14V24C16.5 24.55 16.3043 25.021 15.913 25.413C15.5217 25.805 15.0507 26.0007 14.5 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseScheduleIcon);
export default __webpack_public_path__ + "static/media/pause-schedule-icon.7841d05c0ce1b28c529e0f04db7822c2.svg";
export { ForwardRef as ReactComponent };